import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';

import { DefaultService } from 'src/app/core/framework/default-service';
import { ErrorHandlerService } from 'src/app/core/framework/error-handler.service';
import { ListaResultset } from 'src/app/core/list/lista-resultset.interface';
import { ListaComponent } from 'src/app/core/list/lista.component';
import { IEndereco } from '../endereco.interface';


@Injectable({
  providedIn: 'root'
})
export class EnderecoService extends DefaultService<IEndereco> {

  static URL = '/api/endereco/v1/enderecos'

  constructor(
    public httpClient: HttpClient,
    public errorHandler: ErrorHandlerService
  ) {
      super(
        httpClient,
        errorHandler,
        EnderecoService.URL
      );
  }

  fetch(id: number): Observable<IEndereco> {
    throw new Error('Este serviço não possui este método');
  }

  listar(filter: any, listComponent?: ListaComponent): Observable<ListaResultset<IEndereco>> {
    throw new Error('Este serviço não possui este método');
  }

  inserir(item: IEndereco): Observable<IEndereco> {
    throw new Error('Este serviço não possui este método');
  }

  excluir(id: number): Observable<void> {
    throw new Error('Este serviço não possui este método');
  }



}
